export default {"src":"/_next/static/media/0xe41d2489571d322189246dafa5ebde1f4699f498.3b924903.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};